// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icons {
    display: flex;
    flex-wrap: wrap;
    padding: 0% 5%;
}

.icons .icon {
    cursor: pointer;
    position: relative;
    width: 120px;
    height: 120px;
    margin: 40px;
    transition: .3s ease-out;
}

.icons .icon:hover {
    scale: 1.15;
}

.icons .icon .bg {
    position: absolute;
    top: -10px;
    right: -10px;
    width: 100%;
    height: 100%;
    border-radius: 18px;
    transform: rotate(14deg);
    transition: .3s ease-out;
}

.icons .icon:hover .bg {
    transform: rotate(24deg);
}

.icons .icon:nth-child(1) .bg {
    background: #1598fd;
}

.icons .icon:nth-child(2) .bg {
    background: #0077b5;
}

.icons .icon:nth-child(3) .bg {
    background: #34a853;
}

.icons .icon:nth-child(4) .bg {
    background: #ff4500;
}

.icons .icon:nth-child(5) .bg {
    background: #6159a7;
}

.icons .icon:nth-child(6) .bg {
    background: #1d202d;
}

.icons .icon .glass {
    width: 100%;
    height: 100%;
    display: grid;
    place-items: center;
    backdrop-filter: blur(15px);
    background: rgba(255, 255, 255, .2);
    border: 2px solid rgba(255, 255, 255, .2);
    border-radius: 18px;
}

.icons .icon i {
    font-size: 65px;
    color: white;
    background: linear-gradient(45deg,
            rgba(255, 255, 255, 1),
            rgba(255, 255, 255, .3));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

/* Media queries for responsive design */
@media (max-width:2680px) and (min-width:1821px) {
    .icon {
        width: 190px !important;
        height: 190px !important;
        margin: 30px !important;
    }
}

@media (max-width: 1820px) and (min-width: 1441px) {
    .icon {
        width: 175px !important;
        height: 175px !important;
        margin: 30px !important;
    }
}

@media (max-width: 1439px) and (min-width: 1025px) {
    .icon {
        width: 160px !important;
        height: 160px !important;
        margin: 25px !important;
    }
}

@media (max-width: 1023px) and (min-width: 769px) {
    .icon {
        width: 150px !important;
        height: 150px !important;
        margin: 20px !important;
    }
}

@media (max-width: 768px) and (min-width: 431px) {
    .icon {
        width: 120px !important;
        height: 120px !important;
        margin: 20px !important;
    }
}

@media (max-width: 430px) {
    .icon {
        width: 100px !important;
        height: 100px !important;
        margin: 20px !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/dashboard/styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,wBAAwB;IACxB,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mCAAmC;IACnC,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ;;oCAEgC;IAChC,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA,wCAAwC;AACxC;IACI;QACI,uBAAuB;QACvB,wBAAwB;QACxB,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,uBAAuB;QACvB,wBAAwB;QACxB,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,uBAAuB;QACvB,wBAAwB;QACxB,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,uBAAuB;QACvB,wBAAwB;QACxB,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,uBAAuB;QACvB,wBAAwB;QACxB,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,uBAAuB;QACvB,wBAAwB;QACxB,uBAAuB;IAC3B;AACJ","sourcesContent":[".icons {\n    display: flex;\n    flex-wrap: wrap;\n    padding: 0% 5%;\n}\n\n.icons .icon {\n    cursor: pointer;\n    position: relative;\n    width: 120px;\n    height: 120px;\n    margin: 40px;\n    transition: .3s ease-out;\n}\n\n.icons .icon:hover {\n    scale: 1.15;\n}\n\n.icons .icon .bg {\n    position: absolute;\n    top: -10px;\n    right: -10px;\n    width: 100%;\n    height: 100%;\n    border-radius: 18px;\n    transform: rotate(14deg);\n    transition: .3s ease-out;\n}\n\n.icons .icon:hover .bg {\n    transform: rotate(24deg);\n}\n\n.icons .icon:nth-child(1) .bg {\n    background: #1598fd;\n}\n\n.icons .icon:nth-child(2) .bg {\n    background: #0077b5;\n}\n\n.icons .icon:nth-child(3) .bg {\n    background: #34a853;\n}\n\n.icons .icon:nth-child(4) .bg {\n    background: #ff4500;\n}\n\n.icons .icon:nth-child(5) .bg {\n    background: #6159a7;\n}\n\n.icons .icon:nth-child(6) .bg {\n    background: #1d202d;\n}\n\n.icons .icon .glass {\n    width: 100%;\n    height: 100%;\n    display: grid;\n    place-items: center;\n    backdrop-filter: blur(15px);\n    background: rgba(255, 255, 255, .2);\n    border: 2px solid rgba(255, 255, 255, .2);\n    border-radius: 18px;\n}\n\n.icons .icon i {\n    font-size: 65px;\n    color: white;\n    background: linear-gradient(45deg,\n            rgba(255, 255, 255, 1),\n            rgba(255, 255, 255, .3));\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n\n/* Media queries for responsive design */\n@media (max-width:2680px) and (min-width:1821px) {\n    .icon {\n        width: 190px !important;\n        height: 190px !important;\n        margin: 30px !important;\n    }\n}\n\n@media (max-width: 1820px) and (min-width: 1441px) {\n    .icon {\n        width: 175px !important;\n        height: 175px !important;\n        margin: 30px !important;\n    }\n}\n\n@media (max-width: 1439px) and (min-width: 1025px) {\n    .icon {\n        width: 160px !important;\n        height: 160px !important;\n        margin: 25px !important;\n    }\n}\n\n@media (max-width: 1023px) and (min-width: 769px) {\n    .icon {\n        width: 150px !important;\n        height: 150px !important;\n        margin: 20px !important;\n    }\n}\n\n@media (max-width: 768px) and (min-width: 431px) {\n    .icon {\n        width: 120px !important;\n        height: 120px !important;\n        margin: 20px !important;\n    }\n}\n\n@media (max-width: 430px) {\n    .icon {\n        width: 100px !important;\n        height: 100px !important;\n        margin: 20px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
